"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.input = exports.root = void 0;

var _util = require("../../../util");

const root = ({
  theme
}) => ({
  display: 'inline-block',
  fontSize: theme.checkboxes.inputSize,
  height: theme.checkboxes.inputSize,
  position: 'relative',
  width: theme.checkboxes.inputSize
});

exports.root = root;

const input = ({
  theme
}) => ({
  appearance: 'none',
  color: 'transparent',
  cursor: 'pointer',
  height: '100%',
  margin: 0,
  position: 'absolute',
  width: '100%',
  zIndex: 2,
  '& ~ svg': {
    color: (0, _util.color)(theme, theme.checkboxes.color),
    height: '100%',
    position: 'absolute',
    transition: 'transform 0.2s ease',
    width: '100%'
  },
  '& + svg, ~ svg': {
    height: '100%',
    width: '100%'
  },
  ':checked ~ svg': {
    color: (0, _util.color)(theme, theme.checkboxes.colorChecked)
  },
  ':disabled ~ svg': {
    color: (0, _util.color)(theme, theme.checkboxes.colorDisabled)
  },
  ':not(:checked) ~ svg:last-of-type': {
    transform: 'scale(0)'
  }
});

exports.input = input;
//# sourceMappingURL=Checkbox.style.js.map